import { render } from "./TPCommonIcon.vue?vue&type=template&id=5fb2a3e7&scoped=true&ts=true"
import script from "./TPCommonIcon.vue?vue&type=script&lang=ts"
export * from "./TPCommonIcon.vue?vue&type=script&lang=ts"

import "./TPCommonIcon.vue?vue&type=style&index=0&id=5fb2a3e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb2a3e7"]])

export default __exports__